import { defineMessages } from 'react-intl'

export default defineMessages({
  AssignmentWarning: {
    id: 'app.containers.UserManagement.assignmentWarning',
    defaultMessage:
      'Please note that adding a destination for a swimlane could result in the creation of thousands of notifications or tickets in the integrated platform.',
  },
})
